import { render } from "./ModalEditAplicacao.vue?vue&type=template&id=461a25e6"
import script from "./ModalEditAplicacao.vue?vue&type=script&lang=js"
export * from "./ModalEditAplicacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__